import ShieldCheckIcon from "@/assets/icons/why-trackmate/benefits/shield-check.svg?react";
import PuzzleIcon from "@/assets/icons/why-trackmate/benefits/puzzle-piece.svg?react";
import LockClosedIcon from "@/assets/icons/why-trackmate/benefits/lock-closed.svg?react";
import BanknotesIcon from "@/assets/icons/why-trackmate/benefits/banknotes.svg?react";
import ReceiptPercentIcon from "@/assets/icons/why-trackmate/benefits/receipt-percent.svg?react";
import MapIcon from "@/assets/icons/why-trackmate/benefits/map.svg?react";

export const options = [
  {
    label: "Driver behavior and safety",
    description: "Unlock a new level of operational excellence with Trackmate`s Driver Behavior and Safety feature.",
    sx: {
      top: "36px", 
      left: "0px"
    },
    speed: 0.04,
    icon: ShieldCheckIcon
  },
  {
    label: "Works on any vehicle",
    description: "Unlock a new level of operational excellence with Trackmate's Driver Behavior and Safety feature.",
    sx: {
      top: "0px",
      right: { xs: "20%", md: "40%" },
      justifyContent: "center"
    },
    speed: 0.02,
    icon: PuzzleIcon
  },
  {
    label: "Remote Door lock/unlock",
    description: "Unlock a new level of operational excellence with Trackmate's Driver Behavior and Safety feature.",
    sx: {
      top: { xs: "140px", md: "88px" },
      right: "0px"
    },
    speed: 0.01,
    icon: LockClosedIcon
  },
  {
    label: "Quick ROI",
    description: "Unlock a new level of operational excellence with Trackmate's Driver Behavior and Safety feature.",
    sx: {
      top: { xs: "190px", md: "400px" }, 
      left: "0px"
    },
    speed: 0.02,
    icon: BanknotesIcon
  },
  {
    label: "Insurance premium discounts",
    description: "Unlock a new level of operational excellence with Trackmate's Driver Behavior and Safety feature.",
    sx: {
      top: { xs: "250px", md: "375px" }, 
      right: { xs: "20%", md: "40%" },
    },
    speed: 0.03,
    icon: ReceiptPercentIcon
  },
  {
    label: "Live location",
    description: "Unlock a new level of operational excellence with Trackmate's Driver Behavior and Safety feature.",
    sx: {
      top: { xs: "210px", md: "400px" }, 
      right: "0px"
    },
    speed: 0.02,
    icon: MapIcon
  }
]